import React from 'react'
import { useLocation } from '@reach/router'
import paginate from 'jw-paginate'
import { DiseaseList } from '../DiseaseList'
import { parseSearchParams } from '../../utils'

function CustomDiseaseSearchResult({
  data: { pageContext, ...pageData },
  // component props
  // ページあたりの表示件数
  pageSize = 20,
  // ページネーション数
  totalPages = 5,
  listClassName = 'row',
  paginationClassName = 'pagination',
}) {
  const [result, setResult] = React.useState([])
  const { search } = useLocation()
  const [params, setParams] = React.useState(() => parseSearchParams(search))
  React.useEffect(() => setParams(parseSearchParams(search)), [search])

  const pageAllContentfulDisease = pageData.allContentfulDisease.nodes
    .filter((node) => {
      //キーワード検索
      // 半角、全角スペースを考慮
      const query = params.q?.split(/[ 　]/) || []
      return (
        query.length === 0 ||
        query.some((q) => node.body.internal.content.includes(q))
      )
    })
    .filter((node) => {
      // 50音検索（あ行、か行、など）
      const pattern = params.h || ''
      const regex = new RegExp(`^[${pattern}]`)
      return pattern === '' || node.titleKana.match(regex)
    })
    .filter((node) => {
      // 体の部位から探す
      const part = params.p || ''
      return part === '' || node.partsLabel.includes(part)
    })

  const pagination = paginate(
    pageAllContentfulDisease.length,
    params.page || 1,
    pageSize,
    totalPages
  )

  React.useEffect(() => {
    setResult(
      pageAllContentfulDisease.slice(
        pagination.startIndex,
        pagination.endIndex + 1
      )
    )
  }, [params])

  const handleOnClick = (e, params) => {
    e.preventDefault()
    setParams((state) => ({
      ...state,
      ...params,
    }))
  }

  return (
    result.length > 0 && (
      <>
        <DiseaseList data={result} className={listClassName} />
        {pagination.pages.length > 1 && (
          <div className={paginationClassName}>
            <ul>
              {paginationElement({
                onClick: (e) =>
                  handleOnClick(e, { page: pagination.currentPage - 1 }),
                linkText: '前へ',
                disabled: pagination.currentPage === 1,
              })}
              {pagination.pages.map((pageNumber, index) => {
                const isCurrent = pageNumber === pagination.currentPage
                return (
                  <React.Fragment key={index}>
                    {paginationElement({
                      onClick: (e) => handleOnClick(e, { page: pageNumber }),
                      linkText: pageNumber,
                      disabled: isCurrent,
                    })}
                  </React.Fragment>
                )
              })}
              {paginationElement({
                onClick: (e) =>
                  handleOnClick(e, { page: pagination.currentPage + 1 }),
                linkText: '次へ',
                disabled: pagination.currentPage === pagination.totalPages,
              })}
            </ul>
          </div>
        )}
      </>
    )
  )
}

const paginationElement = ({ onClick, linkText, disabled = false }) => (
  <li>
    <button onClick={onClick} disabled={disabled}>
      {linkText}
    </button>
  </li>
)

export { CustomDiseaseSearchResult }
